import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the block editor a "Blocks" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blocks')({
  staticData: { crumb: 'common:nav.blocks' },
  component: Outlet,
});
